import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.sass'],
})
export class StepperComponent {
  @Input() steps: string[];
  @Input() stepNumber = 0;
}
